import { gql } from "@apollo/client";

export const FINDING_STATES_FIELDS = gql`
  fragment FindingStatesFields on FindingState {
    score
    age
    action
    securityPipeline
    ticket
    exception
    overall
    enforcement
  }
`;
